export enum SettingId {
  ShowSaveMessage = "Show save message",
  ShowUnobtainedCards = "Show unobtained cards",
}
